import React, { useState } from "react";
import { Box } from "@mui/material";
import ImageIcon from "@mui/icons-material/Image";

const ImageWithPlaceholder = ({ src, alt, size = 100, iconSize = 50, borderRadius = '50%' }) => {
  const [imageError, setImageError] = useState(false);

  return imageError || !src ? (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: borderRadius,
        backgroundColor: "#f0f0f0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin:'auto'
      }}
    >
      <ImageIcon sx={{ fontSize: iconSize, color: "#9e9e9e" }} />
    </Box>
  ) : (
    <img
      src={src}
      alt={alt}
      onError={() => setImageError(true)}
      style={{
        width: size,
        height: size,
        borderRadius: borderRadius,
        objectFit: "cover",
      }}
    />
  );
};

export default ImageWithPlaceholder;
